export const SHOW_SET = 'at/userManagement/createTeamAssignmentPanel/SHOW_SET'



// WEBPACK FOOTER //
// ./web/js/panels/user/createTeamAssignmentsPanel/actionTypes.js